import { RefreshableItem } from './refreshableItem';
import { ProviderCapability } from './providerCapability';

// Mapping of refreshable items to capabilities: github.com/tink-ab/tink-backend/blob/702a9b0340a27a8ce41c1b9b78f0be0f993f9a24/src/main-system-features/provider_capability/src/main/java/se/tink/libraries/providercapability/validation/ProviderCapabilityValidator.java#L22

export const CAPABILITY_MAPPER: { [key in RefreshableItem]: ProviderCapability[] } = {
  [RefreshableItem.CHECKING_ACCOUNTS]: [ProviderCapability.CHECKING_ACCOUNTS],
  [RefreshableItem.CHECKING_TRANSACTIONS]: [ProviderCapability.CHECKING_ACCOUNTS],
  [RefreshableItem.CREDITCARD_ACCOUNTS]: [ProviderCapability.CREDIT_CARDS],
  [RefreshableItem.CREDITCARD_TRANSACTIONS]: [ProviderCapability.CREDIT_CARDS],
  [RefreshableItem.EINVOICES]: [ProviderCapability.EINVOICES],
  [RefreshableItem.IDENTITY_DATA]: [ProviderCapability.IDENTITY_DATA],
  [RefreshableItem.INVESTMENT_ACCOUNTS]: [ProviderCapability.INVESTMENTS],
  [RefreshableItem.INVESTMENT_TRANSACTIONS]: [ProviderCapability.INVESTMENTS],
  [RefreshableItem.LIST_BENEFICIARIES]: [ProviderCapability.LIST_BENEFICIARIES],
  [RefreshableItem.LOAN_ACCOUNTS]: [ProviderCapability.LOANS],
  [RefreshableItem.LOAN_TRANSACTIONS]: [ProviderCapability.LOANS],
  [RefreshableItem.SAVING_ACCOUNTS]: [ProviderCapability.SAVINGS_ACCOUNTS],
  [RefreshableItem.SAVING_TRANSACTIONS]: [ProviderCapability.SAVINGS_ACCOUNTS],
  [RefreshableItem.TRANSFER_DESTINATIONS]: [ProviderCapability.TRANSFERS],
};
